import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  userSuccess: 'user-success-toast',
  userError: 'user-error-toast',
  fetchError: 'fetch-error-toast'
};

const EditUserManagement = () => {
  const navigate = useNavigate();
  const { userId } = useParams(); // Assume the user ID is passed in the URL

  console.log("userId", userId);

  // Input States
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [rolesData, setRolesData] = useState([]);

  // Permissions State
  const [permissions, setPermissions] = useState({
    dashboard: { view: false },
    registration: {
      view: false,
      download: false,
      edit: false,
      approval: false,
    },
    investment: { view: false, download: false },
    bond: { view: false, create: false, edit: false, delete: false },
    cms: { manage: false },
    report: { view: false, upload: false, delete: false },
    user: {
      view: false,
      addRole: false,
      create: false,
      edit: false,
      delete: false,
    },
  });

  const fetchUserData = async () => {
    // Replace with actual API call

    const endpoint = `${base_url}/${api_type}/userManagement/${userId}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      // toast.success(response?.data?.message);
      console.log("featch user details", response);
      setFirstName(response?.data?.data?.userDetails?.name);
      // setMiddleName(response?.data?.data?.userDetails.middleName);
      // setLastName(response?.data?.data?.userDetails.lastName);
      setRole(response?.data?.data?.userDetails?.role?.id);
      setEmail(response?.data?.data?.userDetails.email);
      setMobile(response?.data?.data?.userDetails?.mobileNumber);
      setPermissions(response?.data?.data?.userDetails?.permissions);
    } catch (err) {
      if (err?.response?.data?.message === "Access denied") {
        navigate("/");
      }
      if (!toast.isActive(toastIds.fetchError)) {
        toast.error(err?.response?.data?.message, {
          toastId: toastIds.fetchError,
          autoClose: 3000
        });
      }
      console.error("Failed to fetch user:", err);
    }

    const userData = {
      firstName: "name",
      middleName: "M.",
      lastName: "Doe",
      role: "Admin",
      email: "john.doe@example.com",
      mobile: "1234567890",
      permissions: {
        dashboard: { view: true },
        registration: {
          view: true,
          download: false,
          edit: true,
          approval: false,
        },
        investment: { view: true, download: true },
        bond: { view: true, create: false, edit: true, delete: false },
        cms: { manage: true },
        report: { view: true, upload: false, delete: false },
        user: {
          view: true,
          addRole: false,
          create: false,
          edit: true,
          delete: false,
        },
      },
    };

    // Simulate setting the fetched data
    // setFirstName(userData.firstName);
    // setMiddleName(userData.middleName);
    // setLastName(userData.lastName);
    // setRole(userData.role);
    // setEmail(userData.email);
    // setMobile(userData.mobile);
    // setPermissions(userData.permissions);
  };

  // Checkbox Change Handler
  const handleCheckboxChange = (feature, capability) => {
    setPermissions((prev) => ({
      ...prev,
      [feature]: {
        ...prev[feature],
        [capability]: !prev[feature][capability],
      },
    }));
  };

  // Save Button Handler
  const handleSave = async () => {
    // Collect all the data
    const updatedUserData = {
      name: firstName,
      roleId: role,
      email,
      mobileNumber: mobile,
      permissions,
    };

    // Simulate API call (log data in the console)
    console.log("Updated User Data:", updatedUserData);
    // alert("User updated successfully!");

    const endpoint = `${base_url}/${api_type}/userManagement/${userId}`;

    try {
      const response = await axios.put(endpoint, updatedUserData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (!toast.isActive(toastIds.userSuccess)) {
        toast.success(response?.data?.message, {
          toastId: toastIds.userSuccess,
          autoClose: 3000,
          onClose: () => window.location.reload()
        });
      }

    } catch (err) {
      if (err?.response?.data?.errors) {
        if (!toast.isActive(toastIds.userError)) {
          toast.error(err?.response?.data?.errors[0]?.msg, {
            toastId: toastIds.userError,
            autoClose: 3000
          });
        }
      } else {
        if (!toast.isActive(toastIds.userError)) {
          toast.error(err?.response?.data?.message || "Failed to update user", {
            toastId: toastIds.userError,
            autoClose: 3000
          });
        }
      }
      console.error("Failed to update user:", err);
    }
  };

  const getRoles = async () => {
    const endpoint = `${base_url}/${api_type}/roles`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      // toast.success(response?.data?.message);
      if (response?.data?.data?.roles) {
        // Filter unique roles based on 'roleName'
        const uniqueRoles = Array.from(
          new Map(
            response.data.data.roles.map((role) => [role.name, role])
          ).values()
        );
        setRolesData(uniqueRoles); // Set unique roles data
      }
      console.log("response getRoles", response);
    } catch (err) {
      toast.success(err?.response.data?.message);
      console.error("Failed to send link:", err);
    }
  };

  // Close Button Handler
  const handleClose = () => {
    navigate("/dashboard");
  };

  useEffect(() => {
    fetchUserData();
    getRoles();
  }, [userId]);

  console.log("role", role);
  console.log("permissions", permissions);

  return (
    <div className="w-full mt-[60px] pl-4">
      <div>
        <button
          onClick={() => navigate("/user/creation")}
          className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
        >
          ← Back
        </button>
      </div>
      <div className="bg-white rounded-lg pt-6 pb-6 mt-3 border border-1 border-gray-300">
        <h2 className="text-lg font-medium px-5">Edit User</h2>
        <div className="border-b border-1 border-gray-300 pb-2"></div>

        {/* Inputs for user details */}
        <div className="flex flex-wrap gap-6 px-5 pt-5">
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">Name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter Name"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">Role</label>
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
              required
            >
              <option value="" disabled>
                Select role
              </option>
              {rolesData?.map((role) => (
                <>
                  {console.log("rolerole", role)}
                  <option value={role?.id}>{role?.name}</option>
                </>
              ))}
              {/* <option value="User">User</option>
              <option value="Manager">Manager</option> */}
            </select>
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">Email ID</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="text-gray-600 text-sm block mb-2">
              Mobile No.
            </label>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter Mobile No."
              className="w-full h-10 p-2.5 border-none rounded bg-gray-100"
            />
          </div>
        </div>
      </div>

      {/* Permissions Table */}
      {/* Permissions Table */}
      <div className="w-full border border-gray-200 rounded-md">
        <div className="grid grid-cols-2 bg-gray-100 font-semibold px-6 py-3">
          <span>Feature</span>
          <span>Capabilities</span>
        </div>

        {permissions &&
          Object.keys(permissions).map((feature) => (
            <div key={feature} className="grid grid-cols-2 p-6 border-b">
              <span className="font-semibold capitalize">{feature}</span>
              <div className="space-y-2 text-gray-600 font-medium">
                {Object.keys(permissions[feature]).map((capability) => (
                  <label key={capability} className="block">
                    <input
                      type="checkbox"
                      checked={permissions[feature][capability]}
                      onChange={() => handleCheckboxChange(feature, capability)}
                      className="mr-2"
                    />
                    {capability.charAt(0).toUpperCase() + capability.slice(1)}
                  </label>
                ))}
              </div>
            </div>
          ))}
      </div>
      {/* Same as the AddUserManagement component */}

      <div className="flex justify-end space-x-3 mt-4 mr-[130px]">
        <div className="flex">
          <div
            onClick={handleClose}
            className="mr-4 min-w-[150px] text-[#035C98] rounded-[8px] border-2 py-1 px-4 flex justify-center cursor-pointer"
          >
            Close
          </div>
          <div
            onClick={handleSave}
            className="min-w-[150px] bg-[#035C98] text-white rounded-[8px] border-2 py-1 px-4 flex justify-center cursor-pointer"
          >
            Save
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserManagement;
